<p-tabView orientation="right" (onChange)="selectTab($event)" [activeIndex]="index">
    <ng-container>
        <p-tabPanel [header]="'Details'">
            <acabim-admin-edit-account
                [accountDetail]="detailData"
                [classId]="classId"
                [classes]="classes"
                (closeModal)="closeModal($event)"></acabim-admin-edit-account>
        </p-tabPanel>
        <p-tabPanel [header]="'Advanced'">
            <acabim-admin-advanced [accountDetail]="detailData"></acabim-admin-advanced>
        </p-tabPanel>
        <p-tabPanel [header]="'Third-Party'">
            <acabim-admin-third-party></acabim-admin-third-party>
        </p-tabPanel>
    </ng-container>
</p-tabView>
